import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MypageCompleteCard from '../../uiParts/card/MypageCompleteCard';
import CustomSnackbar from '../../uiParts/form/CustomSnackbar';
import SideBar from '../../uiParts/menu/SideBar';
import { useAuthRedirect } from '../../../hooks/useAuthRedirect';
import MetaTitle from '../../utils/MetaTitle';
import { usePageLayout } from '../../../hooks/usePageLayout';

const StaffInviteComplete: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);

  // 未認証ならログイン画面へ退避する（元URLは ?redirect= で引き継ぐ。#3203）
  useAuthRedirect();
  const { sideBarCollapsed, toggleSidebar, styles: layoutStyles } = usePageLayout();

  useEffect(() => {
    const handlePopState = (): void => {
      setSnackbarOpen(true);
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <Box sx={layoutStyles.pageWrapper}>
      <MetaTitle />
      <Box sx={[layoutStyles.sidebar, sideBarCollapsed && layoutStyles.sidebarCollapsed]}>
        <SideBar collapsed={sideBarCollapsed} onToggle={toggleSidebar} />
      </Box>
      <Box
        sx={[
          layoutStyles.pageContent,
          sideBarCollapsed && layoutStyles.pageContentCollapsed,
          { justifyContent: 'center', alignItems: 'center', minHeight: '100vh' },
        ]}
      >
        <MypageCompleteCard
          IconComponent={MailOutlineIcon}
          titleText={'ご登録メールアドレスに\n認証メールを送信しました'}
          isMessageCenter
          messageText={
            'まだ担当者の追加は完了していません。\nお送りしたメールの内容に従って登録してください。\n有効期限を過ぎた場合は、管理者へ再招待を依頼してください。'
          }
          buttonText="担当者一覧へ"
          targetPath="/staff"
        />
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={(): void => setSnackbarOpen(false)}
        text=""
        infoText="前のページに戻れません。"
      />
    </Box>
  );
};

export default StaffInviteComplete;
